/**
 * Dựng tệp CSV UTF-8 có BOM để Excel đọc đúng dấu tiếng Việt (`csv.ts` của web-portal native). Hàm thuần: trả chuỗi,
 * phía gọi tự lưu tệp (`lib/luu-tep.ts`).
 */

const BOM = '﻿';
/** Ô bắt đầu bằng các ký tự này bị Excel hiểu là công thức (CSV injection): thêm `'` phía trước. */
const DAU_CONG_THUC = /^[=+@\-\t\r]/;

function o(v: unknown): string {
  let s = v == null ? '' : String(v);
  if (DAU_CONG_THUC.test(s)) s = `'${s}`;
  return `"${s.replace(/"/g, '""')}"`;
}

export function taoCsv(tieuDe: readonly string[], dong: readonly (readonly unknown[])[]): string {
  return BOM + [tieuDe, ...dong].map((d) => d.map(o).join(',')).join('\r\n');
}

/** `2026-10-29` theo giờ máy người dùng — cho tên tệp. */
export function ngayChoTenTep(d: Date): string {
  const hai = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${hai(d.getMonth() + 1)}-${hai(d.getDate())}`;
}
